import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";

import {
  ContactColumn,
  ProfileInfoCard,
  StatusBadge,
  ViewButton,
} from "@components";

import { ROUTES } from "@constants/routes";

import { EmployeeCommonInfoType } from "@type/HRM/employee-common-info";

const {
  HRM: { DECEASED },
} = ROUTES;

export const TableColumn = (t: TFunction<"translation", undefined>) => {
  return [
    {
      id: 1,
      key: "employee",
      name: t("DECEASED_LIST.TABLE.COLUMN.NAME"),
      render: (employee: EmployeeCommonInfoType) => (
        <ProfileInfoCard employee={employee} viewProfile />
      ),
    },
    {
      id: 2,
      key: "employee",
      name: t("DECEASED_LIST.TABLE.COLUMN.EMPLOYEE_ID"),
      render: (employee: EmployeeCommonInfoType) => (
        <Text color="info" className="text-nowrap">
          {employee.employeeCode}
        </Text>
      ),
    },

    {
      id: 5,
      key: "employee",
      name: t("DECEASED_LIST.TABLE.COLUMN.CONTACTS"),
      render: (employee: EmployeeCommonInfoType) => (
        <ContactColumn employee={employee} />
      ),
    },
    {
      id: 6,
      key: "status",
      name: t("DECEASED_LIST.TABLE.COLUMN.STATUS"),
      render: (status: string) => <StatusBadge status={status} />,
    },
    {
      id: 7,
      key: "reviewer",
      name: t("DECEASED_LIST.TABLE.COLUMN.FILE_ON_HAND"),
      render: (reviewer: EmployeeCommonInfoType, row: any) => {
        return reviewer !== null && row.status !== "APPROVED" ? (
          <ProfileInfoCard employee={reviewer} />
        ) : (
          <></>
        );
      },
    },
    {
      id: 8,
      key: "id",
      name: "",
      render: (id: number) => <ViewButton link={`${DECEASED}/${id}`} />,
    },
  ];
};
